import * as React from 'react';
import {
    View,
    StyleSheet,
} from 'react-native';
import Colors from '../constants/Colors'
import { Ionicons, MaterialCommunityIcons, Feather, MaterialIcons } from '@expo/vector-icons';

export type LibNames = 'Ionicons' | 'MaterialCommunityIcons' | 'Feather' | 'MaterialIcons'

interface IProps {
    size?: number,
    iconName: string,
    iconColor: string,
    outlineColor?: string,
    fillColor?: string,
    iconOnly?: boolean,
    square?: boolean,
    style?: Object,
    iconLibrary?: LibNames
}

const getIconSet = (libraryName: LibNames) => {
    switch (libraryName) {
        case 'Feather':
            return Feather

        case 'Ionicons':
            return Ionicons

        case 'MaterialCommunityIcons':
            return MaterialCommunityIcons

        case 'MaterialIcons':
            return MaterialIcons

        default:
            return Ionicons
    }
}

const StyledIcon: React.FC<IProps> = ({
    size = 24,
    iconName = 'folder',
    iconColor,
    outlineColor,
    fillColor,
    iconOnly,
    square,
    style,
    iconLibrary = 'Feather',
}) => {

    const Icon = getIconSet(iconLibrary)

    return (
        <>
            {!iconOnly
                ? <View
                    style={[
                        styles.wrapper,
                        {
                            width: size,
                            height: size,
                            backgroundColor: fillColor ? fillColor : 'transparent',
                            // borderWidth: outlineColor ? 1 : 0,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            borderColor: outlineColor || fillColor || 'transparent',
                            borderRadius: square ? 3 : size / 2,
                            ...style
                        }
                    ]}
                >
                    {iconName
                        ? <Icon
                            name={iconName}
                            size={(size - (outlineColor ? 2 : 0)) / 1.8 || 24}
                            style={styles.icon}
                            color={iconColor ? iconColor : Colors.tintColor}
                        />
                        : null
                    }
                </View>
                : iconName
                    ? <Icon
                        name={iconName}
                        size={size}
                        style={styles.icon}
                        color={iconColor ? iconColor : Colors.tintColor}
                    />
                    : null

            }
        </>
    )
}

export default StyledIcon

StyledIcon.defaultProps = {
    size: 24,
    iconLibrary: 'Ionicons'
}

const styles = StyleSheet.create({
    wrapper: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        alignSelf: 'center'
    }
})